// ============================================
// Creator Events - Tab & Navigation (ES6)
// 탭, 검색, 통계, 생성 타입 선택 이벤트
// ============================================

import {
  openSearch, closeSearch, handleSearch,
  openSortModal, closeSortModal, setSort,
  openEditor, closeStats,
  openCreationTypeModal, closeCreationTypeModal, selectCreationType
} from '../index.js';

// ============================================
// Creator 탭 이벤트
// ============================================

export function initCreatorTabEvents() {
  // 검색 버튼
  document.querySelector('.creator-search-btn')?.addEventListener('click', openSearch);

  // 정렬 버튼
  document.querySelector('.creator-sort-btn')?.addEventListener('click', openSortModal);

  // 하단바 이벤트 (이벤트 위임)
  const bottomBar = document.querySelector('.creator-bottom-bar');
  bottomBar?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    const action = btn.dataset.action;
    if (action === 'openCreator') {
      openEditor();
    }
  });

  // 정렬 모달 - 배경 클릭 시 닫기
  const sortModal = document.getElementById('creatorSortModal');
  sortModal?.addEventListener('click', (e) => {
    if (e.target === sortModal) closeSortModal();
  });

  // 정렬 옵션 버튼
  document.querySelectorAll('.creator-sort-option').forEach(btn => {
    btn.addEventListener('click', () => {
      const sort = btn.dataset.sort;
      if (sort) setSort(sort);
    });
  });
}

// ============================================
// 검색 모달 이벤트
// ============================================

export function initSearchModalEvents() {
  const searchInput = document.getElementById('creatorSearchInput');
  searchInput?.addEventListener('input', (e) => handleSearch(e.target.value));

  // 취소 버튼
  document.querySelector('#creatorSearchModal .search-close-btn')?.addEventListener('click', closeSearch);
}

// ============================================
// 통계 모달 이벤트
// ============================================

export function initStatsModalEvents() {
  // 뒤로가기 버튼
  document.querySelector('.stats-back-btn')?.addEventListener('click', closeStats);
}

// ============================================
// 생성 타입 선택 모달 이벤트
// ============================================

export function initCreationTypeModalEvents() {
  const modal = document.getElementById('creationTypeModal');

  // 배경 클릭 시 닫기
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) closeCreationTypeModal();
  });

  // 닫기 버튼
  document.querySelector('.creation-type-close')?.addEventListener('click', closeCreationTypeModal);

  // 타입 선택 버튼 (이벤트 위임 - data-type 사용)
  const optionsContainer = modal?.querySelector('.creation-type-options');
  optionsContainer?.addEventListener('click', (e) => {
    const option = e.target.closest('.creation-type-option');
    if (option) {
      const type = option.dataset.type;
      if (type) selectCreationType(type);
    }
  });
}

